module.exports = __webpack_public_path__ + "img/8.17f2e7cd.png";